export default __webpack_public_path__ + "static/media/limit_20.0fdb0207.svg";